module.exports = __webpack_public_path__ + "static/media/pin.1d7a7e85.png";